import type { FunctionComponent } from 'react';
import { Button, CardGroup } from '@george-labs.com/design-system';

import { DevToolsButton } from '../DevToolsButton';
import { DevToolsCard } from '../DevToolsCard';
import {
    toggleAllStyles,
    toggleEnlargedTouchTargets,
    toggleMouseCursor,
    toggleVisuallyHiddenText,
    triggerDebugInfo,
} from './gdsBookmarklets';

export const GdsHelpersCard: FunctionComponent = () => (
    <CardGroup noGap className="mt-0 rounded-0">
        <DevToolsCard title="GDS helpers">
            <DevToolsButton icon={Button.ICON.INFO} onClick={triggerDebugInfo}>
                Trigger debug info
            </DevToolsButton>
            <DevToolsButton icon={Button.ICON.PALETTE} onClick={toggleAllStyles}>
                Toggle all styles
            </DevToolsButton>
            <DevToolsButton icon={Button.ICON.SHOW_OFF} onClick={toggleVisuallyHiddenText}>
                Toggle visually hidden text
            </DevToolsButton>
            <DevToolsButton icon={Button.ICON.HAND_CURSOR} onClick={toggleEnlargedTouchTargets}>
                Toggle enlarged touch targets
            </DevToolsButton>
            <DevToolsButton icon={Button.ICON.KEYBOARD} onClick={toggleMouseCursor}>
                Toggle mouse cursor
            </DevToolsButton>
        </DevToolsCard>
    </CardGroup>
);
